export default {
    ticketTransfers: [],
    ticketTransferNotifications: []
}
